import { CardActions, CardContent } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import React from 'react';
import { constants } from '../../constants';
import useWebContext from '../../hooks/useWebContext';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMLink } from '../../ui-elements/MyMLink';
import { OutlinedCustomCard } from '../../ui-parts/OutlinedCustomCard';
import { NavigateLink } from '../../ui-parts/NavigateLink';
import { HomeCenterHeader, HomeMorePageLink, HomeNoContentBox } from "./HomeUtils";

const NewsListItem = ({ NewsId, url, content, newsType, setIsLoading, apiRequest, screenId }) => {
  const clickAction = (url) => {
    // GlobalSiteNewsの場合は別タブ表示
    apiRequest.requestJson('api/news/external-link-transition?newsId=' + NewsId, 'GET', null, null, null);
    window.open(url, '_blank')
  }

  return (
    <CardActions sx={{ padding: "13px 8px" }}>
      <ListItem disablePadding>
        {
          newsType === constants.NewsType.GlobalNews ?
            <MyMLink onClick={() => clickAction(url)} color="inherit" underline="hover" sx={{ textAlign: "left" }}>
              <MyMLabel>{content}</MyMLabel>
            </MyMLink>
            :
            <NavigateLink to={`/MyM102/MyM502/${NewsId}`} color="inherit" target='_blank' underline="hover" sx={{ textAlign: "left" }}>
              <MyMLabel>{content}</MyMLabel>
            </NavigateLink>
        }
      </ListItem>
    </CardActions>
  )
}

export const HomeMiningNewsCard = ({ screenId, miningNews, setIsLoading, apiRequest }) => {
  const { controlSettings, messageList } = useWebContext(screenId);

  return (
    <OutlinedCustomCard sx={{ display: 'flex', flexDirection: 'column', height: '369px' }}>
      <HomeCenterHeader title={controlSettings.LabelList.lblMiningNewsTitle} />
      <CardContent sx={{
        "&:last-child": {
          paddingBottom: "0px"
        },
        flex: 1,
        padding: 0,
        overflowY: "auto",
        height: '90%',
      }}>
        {
          miningNews.length > 0 ?
            <List sx={{ paddingTop: "0px", paddingBottom: "0px", }}>
              {miningNews.map((item) => {
                return (
                  <NewsListItem
                    NewsId={item.NewsId}
                    url={item.Url}
                    content={`${item.PublishDate} - ${item.Title}`.replace(/null/g, "")}
                    newsType={item.NewsType}
                    key={String(item.NewsId)}
                    setIsLoading={setIsLoading}
                    apiRequest={apiRequest}
                    screenId={screenId}
                  />
                )
              })}
            </List>
            :
            <HomeNoContentBox content={messageList.MyM_MSG_I_0059} />
        }
        <HomeMorePageLink listData={miningNews} href='/MyM102/MyM501' displayContent={controlSettings.LabelList.lnkSeeMoreNews} />
      </CardContent>
    </OutlinedCustomCard>
  )
}